import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import axios from 'axios';
import Axios from 'axios/lib/core/Axios';
import utils from 'axios/lib/utils';
import findIndex from 'lodash/findIndex';
import isArray from 'lodash/isArray';
import uniqueId from 'lodash/uniqueId';
import isPlainObject from 'lodash/isPlainObject';
import InterceptorManager from 'axios/lib/core/InterceptorManager';
import { initDefaultInterceptors, kdocsLocalAdapter, setInterceptors } from '@kso/axios/lib/util';
import { isKaeRelease } from '@kso/util';
import plugctr from '@kso/axios/lib/plugctr';
export { default as Cancel } from 'axios/lib/cancel/Cancel';

var _axios_ = axios;
if (isKaeRelease('oem')) {
  inject(axios);
}
var axiosDefaultAdapter = axios.defaults.adapter; // 提前保存默认适配器
/* ECIS start */
/* @Description: 统一接口拦截 */
var ecisFlag = _axios_.interceptors.request.handlers && _axios_.interceptors.request.handlers.find(function (item) {
  return item.fulfilled && item.fulfilled.ecisInterceptor;
});
if (!ecisFlag) {
  var ecisReqFn = function ecisReqInterceptor(config) {
    return plugctr.ask('request', config, config);
  };
  ecisReqFn.ecisInterceptor = true;
  var ecisUse = _axios_.interceptors.request.use;
  _axios_.interceptors.request.use = function () {
    var _this = this;
    var ecisFn = null;
    if (_axios_.interceptors.request && _axios_.interceptors.request.handlers && _axios_.interceptors.request.handlers.length > 0) {
      var ecisIdx = _axios_.interceptors.request.handlers.findIndex(function (t) {
        return t.fulfilled && t.fulfilled.ecisInterceptor;
      });
      if (ecisIdx > -1) {
        ecisFn = _axios_.interceptors.request.handlers.splice(ecisIdx, 1)[0];
      }
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var result = ecisUse.call.apply(ecisUse, [_this].concat(args));
    if (ecisFn && !(args && args[0] && args[0].ecisInterceptor)) {
      _axios_.interceptors.request.handlers.push(ecisFn);
    }
    return result;
  };
  _axios_.interceptors.request.use(ecisReqFn);
}
var ecisFlagRes = _axios_.interceptors.response.handlers && _axios_.interceptors.response.handlers.find(function (item) {
  return item.fulfilled && item.fulfilled.ecisInterceptor;
});
if (!ecisFlagRes) {
  var ecisResFn = function ecisResInterceptor(config) {
    return plugctr.ask('response', config, config);
  };
  ecisResFn.ecisInterceptor = true;
  _axios_.interceptors.response.use(ecisResFn);
}
/* ECIS end */

var _create_ = _axios_.create;
function $ejectAll() {
  this.interceptors.request.$ejectAll();
  this.interceptors.response.$ejectAll();
}
function $inject(interceptor) {
  var _ref = interceptor || {},
    name = _ref.name;
  if (!name) {
    console.error('使用Axios实例的$inject的参数必须指定name');
  } else {
    return setInterceptors(this, interceptor);
  }
}
function addInjector(factory) {
  var args = Array.from(arguments).splice(1);

  // 全局的方法只插入一次
  if (_axios_ === this) {
    this._added__ = this._added__ || [];
    factory.apply(this, args);
  } else {
    factory.apply(this, args);
  }
}

/**
 * @description 注销指定名字的拦截器
 * @param {String} name 拦截器的名字，例如：dwpoint
 */
function ejectByInterceptorName(name) {
  var _this$interceptors = this.interceptors,
    request = _this$interceptors.request,
    response = _this$interceptors.response;
  var reqTargetHandlers = request.handlers.find(function (handler) {
    return handler.refer === name;
  });
  var resTargetHandlers = response.handlers.find(function (handler) {
    return handler.refer === name;
  });
  reqTargetHandlers && request.eject(reqTargetHandlers.__ID__);
  resTargetHandlers && response.eject(resTargetHandlers.__ID__);
}
InterceptorManager.prototype.unshiftUse = function unshiftUse(fulfilled, rejected, refer) {
  var __ID__ = uniqueId();
  var handle = {
    __ID__: __ID__,
    refer: refer,
    fulfilled: fulfilled,
    rejected: rejected
  };
  if (refer) {
    var index = findIndex(this.handlers, function (handle) {
      return handle && handle.refer === refer;
    });
    if (~index) {
      this.handlers.splice(index, 1, handle);
    } else {
      this.handlers.unshift(handle);
    }
  } else {
    this.handlers.unshift(handle);
  }
  return __ID__;
};
InterceptorManager.prototype.use = function use(fulfilled, rejected, refer) {
  var __ID__ = uniqueId();
  var handle = {
    __ID__: __ID__,
    refer: refer,
    fulfilled: fulfilled,
    rejected: rejected
  };
  if (refer) {
    var index = findIndex(this.handlers, function (handle) {
      return handle && handle.refer === refer;
    });
    if (~index) {
      this.handlers.splice(index, 1, handle);
    } else {
      this.handlers.push(handle);
    }
  } else {
    this.handlers.push(handle);
  }
  return __ID__;
};
InterceptorManager.prototype.eject = function use(id) {
  var index = findIndex(this.handlers, function (handle) {
    return handle && handle.__ID__ === id;
  });
  if (this.handlers[index]) {
    this.handlers[index] = null;
  }
  this.handlers = this.handlers.filter(function (i) {
    return i;
  });
};
InterceptorManager.prototype.forEach = function forEach(fn) {
  var globalAxiosHandlers = [];
  var defaults = [];
  // 使用标记
  var isRequestRuntime = this._type_ === 'request';
  var isResponseRuntime = this._type_ === 'response';
  var handlers = Array.from(this.handlers);
  if (isRequestRuntime) {
    if (this.accordanceWithGlobal) {
      globalAxiosHandlers = Array.from(_axios_.interceptors.request.handlers);
    }
    defaults = Array.from(_axios_.defaults.$interceptors.request.handlers);
  } else if (isResponseRuntime) {
    if (this.accordanceWithGlobal) {
      globalAxiosHandlers = Array.from(_axios_.interceptors.response.handlers);
    }
    defaults = Array.from(_axios_.defaults.$interceptors.response.handlers);
  }

  // 前置response
  if (isResponseRuntime) {
    var refers = handlers.reduce(function (pre, cur, index) {
      if (cur && cur.refer) {
        pre.push({
          handle: cur,
          index: index
        });
      }
      return pre;
    }, []);

    // 以当前注册的refer为准
    if (refers.length) {
      var temp = Array.from(globalAxiosHandlers);
      temp.forEach(function (globalHandle, index) {
        var custom = refers.find(function (_ref2) {
          var handle = _ref2.handle;
          return handle.refer === globalHandle.refer;
        });
        if (custom) {
          globalAxiosHandlers.splice(index, 1, custom.handle);
          handlers.splice(custom.index, 1, null);
        }
      });
    }
  } else if (isRequestRuntime) {
    globalAxiosHandlers = globalAxiosHandlers.filter(function (handle) {
      var refers = handlers.reduce(function (pre, cur) {
        if (cur && cur.refer) {
          pre.push(cur.refer);
        }
        return pre;
      }, []);
      return handle && (!handle.refer || !~refers.indexOf(handle.refer));
    });
  }
  var all = [].concat(_toConsumableArray(globalAxiosHandlers), _toConsumableArray(defaults), handlers);
  utils.forEach(all, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};
InterceptorManager.prototype.$ejectAll = function ejectAll() {
  this.handlers = [];
};
Axios.prototype.ejectByInterceptorName = ejectByInterceptorName;
Axios.prototype.addInjector = addInjector;
// 覆盖注入过的 name
Axios.prototype.$inject = $inject;
Axios.prototype.$ejectAll = $ejectAll;
_axios_.defaults.$interceptors = {
  request: new InterceptorManager(),
  response: new InterceptorManager()
};
_axios_.ejectByInterceptorName = ejectByInterceptorName;
_axios_.addInjector = addInjector;
_axios_.$inject = $inject;
_axios_.$ejectAll = $ejectAll;
_axios_.interceptors.request._type_ = 'request';
_axios_.interceptors.response._type_ = 'response';
_axios_.create = function (config) {
  var _ref3 = config || {},
    accordanceWithGlobal = _ref3.accordanceWithGlobal,
    interceptors = _ref3.interceptors;
  var instance = _create_.apply(_axios_, arguments);

  /*
   * 根据create传入的参数是否忽略挂载在Axios上的interceptor
   * 如果有需要需要自己为单个实例创建interceptor
   */
  if (accordanceWithGlobal) {
    instance.interceptors.request.accordanceWithGlobal = true;
    instance.interceptors.response.accordanceWithGlobal = true;
  } else {
    // 不继承Axios上的拦截器的话，重新给它注册默认的拦截器（cstftoken 和 dwpoint）
    initDefaultInterceptors(instance);
  }
  instance.interceptors.request._type_ = 'request';
  instance.interceptors.response._type_ = 'response';
  var _inject_ = function _inject_(injector) {
    if (typeof injector === 'function') {
      injector.call(instance);
    } else if (isPlainObject(injector)) {
      instance.$inject(injector);
    }
  };
  if (isArray(interceptors)) {
    interceptors.forEach(function (i) {
      return _inject_(i);
    });
  } else if (interceptors) {
    _inject_(interceptors);
  }
  /* ECIS start */
  /* @Description: 统一接口拦截 */
  var ecisFlag = instance.interceptors.request.handlers && instance.interceptors.request.handlers.find(function (item) {
    return item.fulfilled && item.fulfilled.ecisInterceptor;
  });
  if (!ecisFlag) {
    var _ecisReqFn = function ecisReqInterceptor(config) {
      return plugctr.ask('request', config, config);
    };
    _ecisReqFn.ecisInterceptor = true;
    var _ecisUse = instance.interceptors.request.use;
    instance.interceptors.request.use = function () {
      var _this = this;
      var ecisFn = null;
      if (instance.interceptors.request && instance.interceptors.request.handlers && instance.interceptors.request.handlers.length > 0) {
        var ecisIdx = instance.interceptors.request.handlers.findIndex(function (t) {
          return t.fulfilled && t.fulfilled.ecisInterceptor;
        });
        if (ecisIdx > -1) {
          ecisFn = instance.interceptors.request.handlers.splice(ecisIdx, 1)[0];
        }
      }
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var result = _ecisUse.call.apply(_ecisUse, [_this].concat(args));
      if (ecisFn && !(args && args[0] && args[0].ecisInterceptor)) {
        instance.interceptors.request.handlers.push(ecisFn);
      }
      return result;
    };
    instance.interceptors.request.use(_ecisReqFn);
  }
  var ecisFlagRes = instance.interceptors.response.handlers && instance.interceptors.response.handlers.find(function (item) {
    return item.fulfilled && item.fulfilled.ecisInterceptor;
  });
  if (!ecisFlagRes) {
    var _ecisResFn = function ecisResInterceptor(config) {
      return plugctr.ask('response', config, config);
    };
    _ecisResFn.ecisInterceptor = true;
    instance.interceptors.response.use(_ecisResFn);
  }
  /* ECIS end */
  return instance;
};

// 初始化默认的拦截器
initDefaultInterceptors(_axios_);
function inject(Axios) {
  var _axios_ = Axios;
  var _create_ = Axios.create;
  try {
    var interceptors = window.interceptors || {
      requestList: [],
      responseList: [],
      unsupportApiConfig: {}
    };
    window.interceptors = interceptors;
    Axios.create = function () {
      var instance = _create_.apply(_axios_, arguments);
      instance.interceptors.request.use(function (conf) {
        interceptors.requestList.forEach(function (item) {
          return item(conf);
        });
        return conf;
      });
      instance.interceptors.response.use(function (conf) {
        interceptors.responseList.forEach(function (item) {
          return item[0](conf);
        });
        return conf;
      }, function (err) {
        interceptors.responseList.forEach(function (item) {
          return item[1](err);
        });
        return Promise.reject(err);
      });
      return instance;
    };
    _axios_.interceptors.request.use(function (conf) {
      interceptors.requestList.forEach(function (item) {
        return item(conf);
      });
      return conf;
    });
    _axios_.interceptors.response.use(function (conf) {
      interceptors.responseList.forEach(function (item) {
        return item[0](conf);
      });
      return conf;
    }, function (err) {
      interceptors.responseList.forEach(function (item) {
        return item[1](err);
      });
      return Promise.reject(err);
    });
  } catch (e) {}
}
try {
  /*
   * 如果非服务端渲染，且在本地环境时使用客户端提供的ajax
   * 很多请求都是没有实例化axios直接发起请求的，无法通过在create方法里面进行修改适配器 所以只能覆盖掉默认的适配器
   */
  if (typeof window !== 'undefined') {
    var kdocsClient = window[window.clientApiKey] || window['$kdocsClient'];
    if (kdocsClient) {
      /*
       * 由于在线或本地化 客户端都会注入 window['$kdocsClient']，需要区分是否为本地化版本 非本地化版本需跟线上保持一致
       * window.$kdocsClient.env().local  ios客户端第一个本地化版本是没有这个属性的，所以需要通过 env().scheme是否为kdochttp来区分
       */
      var useLocalAdapter = kdocsClient.env && (kdocsClient.env().local || kdocsClient.env().scheme.startsWith('kdochttp')) && kdocsClient.ajax;
      if (useLocalAdapter) {
        if (!window.kdocsAxiosDefaultAdapter) {
          window.kdocsAxiosDefaultAdapter = axiosDefaultAdapter;
        }
        _axios_.defaults.adapter = kdocsLocalAdapter;
      }
    }
  }
} catch (_unused) {}

export { _axios_ as default };
